import { AttributeUniqValues } from 'src/generated/operations.ts';
import { AirflowEnum, UserInput } from 'src/actuators/user-input/types.ts';
import { Decimal } from 'decimal.js-light';
import { ActuatorTypes, QueryParams } from 'src/actuators/user-input/calculations/constants.ts';
import { NumberPart } from 'src/actuators/user-input/calculations/caseTwo.ts';

const airflowMap = {
    [AirflowEnum.low]: new Decimal(10),
    [AirflowEnum.mid]: new Decimal(15),
    [AirflowEnum.high]: new Decimal(20),
};

export const handleRoundAm = (
    torques: AttributeUniqValues,
    searchParams: URLSearchParams,
    inputState: UserInput,
    type: ActuatorTypes,
): string => {
    try {
        const areaDecimal = new Decimal(inputState.areaOrDiameter);
        const crankFactor = type === ActuatorTypes.Linear ? new Decimal(2)
            .dividedBy(new Decimal(inputState.crankArmLength))
            .squareRoot() : new Decimal(1);

        const torque = areaDecimal
            .mul(airflowMap[inputState.air])
            .mul(crankFactor);

        const filtered = torques.values
            .map(({ value }) => {
                const curr = new Decimal(value.replace(NumberPart, '$1'));
                return {
                    value,
                    curr,
                    distance: curr.minus(torque),
                };
            })
            .filter(({ distance }) => distance.greaterThanOrEqualTo(0))
            .sort((a, b) => a.distance.cmp(b.distance));

        if (filtered.length > 0) {
            searchParams.set(
                type === ActuatorTypes.Linear ? QueryParams.forces : QueryParams.torques,
                JSON.stringify(filtered.slice(0, 2).map(({ value }) => value)),
            );
        } else {
            searchParams.delete(QueryParams.forces);
            searchParams.delete(QueryParams.torques);
        }
        return torque.toFixed(2);
    } catch {
        // no-op
        return '';
    }
};
